module.exports = __webpack_public_path__ + "static/media/luisa-chen.8e11a08c.png";